import {
  Box,
  Button,
  Grid,
  GridItem,
  Image,
  Input,
  Link,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import SignInVector from "../assets/images/signin-vector.png";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { IoMdLock } from "react-icons/io";
import { useDispatch } from "react-redux";
import { fogotPassword, sendOTP, signIn } from "../api";
import { verifyOTP } from "../redux/auth/AuthSlice";
import { useTimer } from "react-timer-hook";
import { Loader } from "../assets/svgs/Icons";
import cuLogo from "../assets/images/cu_logo.png";
import cuLogo2 from "../assets/images/cu_102.jpg";
import emertechLogo from "../assets/images/Emertech_Logo.png";
import { toast } from "react-toastify";
import GreenTrace from "../assets/green-without-bg.png"
import blockchainImage from "../assets/blockchain-image.jpg"

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPasswordVisble, setIsPasswordVisble] = useState(false);
  const [showOtpComponent, setShowOtpComponent] = useState(false);
  const [showForgotComp, setShowForgotComp] = useState(false);
  const [email, setEmail] = useState("");
  const [isLoading, setIsloading] = useState();
  const [isResendLoading, setIsResendloading] = useState(false);
  const [resendState, setResendState] = useState(false);
  const isOtpPage = localStorage.getItem("otpPage");
  const isForgotPage = localStorage.getItem("forgotpage");
  const emailValue = localStorage.getItem("user-email");

  const time = new Date();
  time.setSeconds(time.getSeconds() + 300);

  const expiryTimestamp = time;

  const { seconds, minutes, restart, start } = useTimer({
    expiryTimestamp,
    onExpire: () => setResendState(true),
    autoStart: true,
  });

  useEffect(() => {
    if (isOtpPage) {
      setShowOtpComponent(true);
    }
    if (isForgotPage) {
      setShowForgotComp(true);
    }
  }, [isOtpPage, isForgotPage]);

  const restartTimer = () => {
    const restartTime = new Date();
    restartTime.setSeconds(restartTime.getSeconds() + 300);
    restart(restartTime);
  };

  const resendOTP = async (email) => {
    setResendState(false);
    let response = await sendOTP(email, setIsResendloading);

    restartTimer();
  };

  useEffect(() => {
    start();
  }, []);

  const boxSize = useBreakpointValue({ base: "220px", md: "auto" });
  const maxH = useBreakpointValue({ base: "250px", md: "none" });

  return (
    <Box>
      <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          backgroundImage={`url(${blockchainImage})`}
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          opacity="0.5"
          zIndex="-1"
        />
        <GridItem colSpan={1}>
          <Box bg={"transparent"} h={"calc(100vh - 0px)"} marginTop="-1rem">
            <Link
              display={"flex"}
              justifyContent="left"
              alignItems={"center"}
              paddingLeft={"2rem"}
              paddingTop="4rem"
              target={"_blank"}
              rel="noreferrer noopener"
              href="https://certifications.controlunion.com/en"
            >

              {/* <Box
                as="span"
                borderRight={"2px solid #aaaa"}
                height="40px"
                marginRight={"1rem"}
              ></Box> */}
              <Image src={GreenTrace} width="250px" />
            </Link>
            <Box paddingLeft={"2rem"} paddingTop="1rem">
              <Text
                color={"#141D43"}
                fontSize={{ base: "lg", md: "lg", lg: "4xl" }}
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Welcome to <br /> Green Trace dashboard
              </Text>
              <Text
                color={" #464C64"}
                fontSize={{ base: "sm", md: "md", lg: "md" }}
              >
                Log into your account and be part of value <br /> chain
                certification
              </Text>
              {/* <Box display={"flex"} justifyContent="right" marginLeft={"-5rem"}>
                <Image
                  h={{ base: "250px", md: "250px", lg: "440px" }}
                  w={{}}
                  src={SignInVector}
                />
              </Box> */}
              {/* <Box >
                <Image
                  src={GreenTrace}
                  h={{ base: "250px", md: "250px", lg: "400px" }}
                  width="500px"
                />
              </Box> */}

            </Box>
            <Image src={cuLogo2} position="absolute"
              bottom="0"
              left="0" width="250px" margin={"2rem"} marginRight={"4rem"} />
          </Box>
        </GridItem>
        <GridItem>
          <Box background={"#EDF3F8"} paddingTop="2rem" width={"100%"} height={"100%"}>
            <Box marginLeft={"4rem"}>
              <Text
                color={"#141D43"}
                fontSize={{ base: "md", md: "lg", lg: "4xl" }}
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Get Started
              </Text>
              <Text color={"#464C64"} fontSize="sm">
                Please add details provided by <br />
                <Box as="span" color={"#3958DC"}>
                  Control Union
                </Box>
              </Text>
              {!showOtpComponent && !showForgotComp ? (
                <Box marginTop={"3rem"}>
                  <Box w="60%">
                    <Formik
                      initialValues={{
                        email: "",
                        password: "",
                      }}
                      onSubmit={async (values, { resetForm }) => {
                        localStorage.setItem("user-email", values.email);
                        let response = await signIn(values, setIsloading);
                        if (response.status) {
                          resetForm();
                          setShowOtpComponent(true);
                          localStorage.setItem("otpPage", "innit");
                        }
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string()
                          .email()
                          .required("Email is required"),
                        password: Yup.string().required(
                          "Please enter your password"
                        ),
                      })}
                    >
                      {(props) => {
                        const {
                          values,
                          touched,
                          errors,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          resetForm,
                        } = props;
                        return (
                          <>
                            <Form>
                              <Box w={"80%"}>
                                <Text
                                  color={"#141D43"}
                                  fontSize={{ base: "sm", md: "sm", lg: "md" }}
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Email{" "}
                                  <Text as="span" color="red">
                                    *
                                  </Text>
                                </Text>
                                <Input
                                  type="email"
                                  color={"#141D43"}
                                  w={{ base: "130%", md: "130%", lg: "100%" }}
                                  marginTop="10px"
                                  id="email"
                                  bg={"#fff"}
                                  placeholder="Email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  fontSize={"14px"}
                                  border={"none"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "  #B8DEF8",
                                    fontSize: "14px",
                                  }}
                                  _focusVisible={
                                    errors.email && touched.email
                                      ? {
                                        border: "1px solid red !important",
                                      }
                                      : { border: "1px solid #3958DC" }
                                  }
                                />
                                {errors.email && touched.email && (
                                  <Box color="red.500" marginTop={"10px"}>
                                    {errors.email}
                                  </Box>
                                )}
                              </Box>
                              <Box
                                marginTop={"10px"}
                                w="80%"
                                position="relative"
                              >
                                <Text
                                  color={"#141D43"}
                                  fontSize={{ base: "sm", md: "sm", lg: "md" }}
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                >
                                  Password{" "}
                                  <Text as="span" color="red">
                                    *
                                  </Text>
                                </Text>
                                <Box>
                                  <Input
                                    type={
                                      isPasswordVisble ? "text" : "password"
                                    }
                                    color={"#141D43"}
                                    marginTop="10px"
                                    w={{ base: "130%", md: "130%", lg: "100%" }}
                                    id="password"
                                    bg={"#fff"}
                                    zIndex="10"
                                    placeholder="Password"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    border={"none"}
                                    fontSize={"14px"}
                                    _placeholder={{
                                      opacity: 1,
                                      color: "  #B8DEF8",
                                      fontSize: "14px",
                                    }}
                                    _focusVisible={
                                      errors.password && touched.password
                                        ? {
                                          border: "1px solid red !important",
                                        }
                                        : { border: "1px solid #3958DC" }
                                    }
                                  />

                                  <Box
                                    onClick={() => {
                                      if (values.password?.length <= 0) return;
                                      setIsPasswordVisble((prev) => !prev);
                                    }}
                                    style={{
                                      top:
                                        errors.password && touched.password
                                          ? "20%"
                                          : "23%",
                                      opacity:
                                        values.password?.length > 0 ? 1 : 0.4,
                                      cursor:
                                        values.password?.length > 0
                                          ? "pointer"
                                          : "not-allowed",
                                      position: "absolute",
                                    }}
                                    cursor="pointer"
                                    right={"10px"}
                                    zIndex="10"
                                  >
                                    {!isPasswordVisble ? (
                                      <AiOutlineEye
                                        color={"#52BBFF"}
                                        size={24}
                                      />
                                    ) : (
                                      <AiOutlineEyeInvisible
                                        color="#52BBFF"
                                        size={24}
                                        marginBottom={"10px"}
                                      />
                                    )}
                                  </Box>
                                  {errors.password && touched.password && (
                                    <Box color="red.500" marginTop={"10px"}>
                                      {errors.password}
                                    </Box>
                                  )}
                                </Box>
                                <Box marginTop={"2rem"} w="100%">
                                  <Button
                                    type="submit"
                                    disabled={isLoading ? true : ""}
                                    // onClick={() => handleSubmit()}
                                    w={{ base: "130%", md: "130%", lg: "100%" }}
                                    bg="#52BBFF"
                                    color={"#fff"}
                                    _hover={{ bg: "#52BBFF" }}
                                  >
                                    {isLoading ? (
                                      <Loader width="25px" height="25px" />
                                    ) : (
                                      "Log In"
                                    )}
                                  </Button>
                                </Box>
                                <Box
                                  color="#3958DC"
                                  cursor={"pointer"}
                                  fontSize={{ base: "sm", md: "sm", lg: "lg" }}
                                  onClick={() => {
                                    setShowForgotComp(true);
                                    setShowOtpComponent(false);
                                    localStorage.setItem(
                                      "forgotpage",
                                      "In forgot page"
                                    );
                                  }}
                                  marginTop={"10px"}
                                >
                                  Forgot Password
                                </Box>
                              </Box>
                            </Form>
                          </>
                        );
                      }}
                    </Formik>
                  </Box>
                </Box>
              ) : (
                ""
              )}
              {showOtpComponent ? (
                <Box marginTop={"3rem"}>
                  <Box
                    display={"flex"}
                    marginBottom="1rem"
                    alignItems="center"
                    cursor={"pointer"}
                    onClick={() => {
                      // resetTimer();
                      setShowOtpComponent(false);
                      localStorage.removeItem("otpPage");
                    }}
                  >
                    <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
                    &nbsp;
                    <Text
                      //#3958DC
                      color={"#52BBFF"}
                      fontSize={{ base: "sm", md: "sm", lg: "md" }}
                      fontWeight={"800"}
                      fontFamily={"font.roboto"}
                    >
                      Go Back
                    </Text>
                  </Box>

                  <Box w="60%">
                    <Formik
                      initialValues={{
                        otp: "",
                      }}
                      onSubmit={async (values, { resetForm }) => {
                        dispatch(verifyOTP(values))
                          .then((response) => {
                            if (!response.error) {
                              resetForm();
                              setShowOtpComponent(false);
                              localStorage.removeItem("otpPage");
                              localStorage.removeItem("user-email");
                              navigate("/dashboard");
                            }
                          })
                          .catch((error) => {
                            setShowOtpComponent(true);
                            console.error(error);
                          });
                      }}
                      validationSchema={Yup.object().shape({
                        otp: Yup.string().required("OTP is required"),
                      })}
                    >
                      {(props) => {
                        const {
                          values,
                          touched,
                          errors,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          resetForm,
                        } = props;
                        return (
                          <>
                            <Box w={{ base: "100%", md: "100%", lg: "80%" }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                margin={"auto"}
                                alignItems={"center"}
                                bgColor={"#dbedfc"}
                                padding="10px"
                                width={"80px"}
                                height="75px"
                                borderRadius={"50%"}
                              >
                                <IoMdLock color={"#52BBFF"} size={35} />
                              </Box>
                              <Text
                                color={"#141D43"}
                                fontSize={{ base: "md", md: "md", lg: "lg" }}
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                                display="flex"
                                justifyContent={"center"}
                                marginTop="1rem"
                              >
                                Enter Code
                              </Text>
                              <Text
                                color={"#141D43"}
                                fontSize="sm"
                                fontWeight={"400"}
                                fontFamily={"font.roboto"}
                                display="flex"
                                justifyContent={"center"}
                              >
                                We sent OTP code on your email address
                              </Text>
                              <Box marginTop={"10px"}>
                                <Input
                                  type="number"
                                  color={"#141D43"}
                                  marginTop="10px"
                                  id="otp"
                                  bg={"#fff"}
                                  placeholder="For example 453.."
                                  value={values.otp}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  fontSize={"14px"}
                                  border={"none"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "  #B8DEF8",
                                    fontSize: "14px",
                                  }}
                                  _focusVisible={
                                    errors.otp && touched.otp
                                      ? {
                                        border: "1px solid red !important",
                                      }
                                      : { border: "1px solid #3958DC" }
                                  }
                                />
                              </Box>
                              {errors.otp && touched.otp && (
                                <Box color="red.500" marginTop={"10px"}>
                                  {errors.otp}
                                </Box>
                              )}
                              <Box
                                display={"flex"}
                                alignItems="center"
                                gap={"1rem"}
                                marginTop="10px"
                              >
                                <Box>
                                  <Button
                                    color="#3958DC"
                                    cursor={"pointer"}
                                    padding={"0"}
                                    disabled={
                                      isResendLoading || !resendState
                                        ? true
                                        : ""
                                    }
                                    fontWeight="400"
                                    _hover={{ bg: "transparent" }}
                                    onClick={() => {
                                      resendOTP(emailValue);
                                    }}
                                  >
                                    Resend OTP
                                  </Button>
                                </Box>
                                {seconds >= 0 ? (
                                  <Box>
                                    <Box
                                      as="span"
                                      color={"#141D43"}
                                      fontWeight="800"
                                    >
                                      0{minutes}:
                                      {seconds < 10 ? `0${seconds}` : seconds}
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Box>
                            <Box marginTop={"10px"} w="80%" position="relative">
                              <Box marginTop={"1rem"} w="100%">
                                <Button
                                  type="submit"
                                  w={"100%"}
                                  onClick={() => handleSubmit()}
                                  bg="#52BBFF"
                                  color={"#fff"}
                                  _hover={{ bg: "#52BBFF" }}
                                >
                                  {isLoading ? (
                                    <Loader width="25px" height="25px" />
                                  ) : (
                                    "Verify OTP"
                                  )}
                                </Button>
                              </Box>
                            </Box>
                          </>
                        );
                      }}
                    </Formik>
                  </Box>
                </Box>
              ) : (
                ""
              )}
              {showForgotComp ? (
                <Box marginTop={"3rem"}>
                  <Box w="60%">
                    <Formik
                      initialValues={{
                        email: "",
                      }}
                      onSubmit={async (values, { resetForm }) => {
                        let response = await fogotPassword(
                          values,
                          resetForm,
                          setIsloading
                        );
                        if (response.status) {
                          localStorage.removeItem("forgotpage");
                          setShowForgotComp(false);
                        }
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string()
                          .email()
                          .required("Email is required"),
                      })}
                    >
                      {(props) => {
                        const {
                          values,
                          touched,
                          errors,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          resetForm,
                        } = props;
                        return (
                          <>
                            <Box
                              display={"flex"}
                              marginBottom="1rem"
                              alignItems="center"
                              cursor={"pointer"}
                              onClick={() => {
                                setShowForgotComp(false);
                                localStorage.removeItem("forgotpage");
                              }}
                            >
                              <IoChevronBackCircleSharp
                                color={"#52BBFF"}
                                size={30}
                              />
                              &nbsp;
                              <Text
                                //#3958DC
                                color={"#52BBFF"}
                                fontSize={{ base: "sm", md: "sm", lg: "md" }}
                                fontWeight={"800"}
                                fontFamily={"font.roboto"}
                              >
                                Go Back
                              </Text>
                            </Box>
                            <Box w={"80%"}>
                              <Text
                                color={"#141D43"}
                                fontSize={{ base: "md", md: "md", lg: "lg" }}
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                                display="flex"
                                justifyContent={"center"}
                                marginTop="1rem"
                              >
                                Enter Email Address
                              </Text>
                              <Text
                                color={"#141D43"}
                                fontSize="sm"
                                fontWeight={"400"}
                                fontFamily={"font.roboto"}
                                display="flex"
                                justifyContent={"center"}
                              >
                                We will email you link to reset password
                              </Text>
                              <Box marginTop={"10px"}>
                                <Input
                                  type="email"
                                  color={"#141D43"}
                                  marginTop="10px"
                                  w={{ base: "130%", md: "130%", lg: "100%" }}
                                  id="email"
                                  bg={"#fff"}
                                  placeholder="For ex.. xyz@gmail.com"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  fontSize={"14px"}
                                  border={"none"}
                                  _placeholder={{
                                    opacity: 1,
                                    color: "  #B8DEF8",
                                    fontSize: "14px",
                                  }}
                                  _focusVisible={
                                    errors.email && touched.email
                                      ? {
                                        border: "1px solid red !important",
                                      }
                                      : { border: "1px solid #3958DC" }
                                  }
                                />
                              </Box>

                              {errors.email && touched.email && (
                                <Box color="red.500" marginTop={"10px"}>
                                  {errors.email}
                                </Box>
                              )}
                            </Box>
                            <Box marginTop={"10px"} w="80%" position="relative">
                              <Box marginTop={"2rem"} w="100%">
                                <Button
                                  disabled={isLoading ? true : ""}
                                  onClick={() => handleSubmit()}
                                  w={{ base: "130%", md: "130%", lg: "100%" }}
                                  bg="#52BBFF"
                                  color={"#fff"}
                                  _hover={{ bg: "#52BBFF" }}
                                >
                                  {isLoading ? (
                                    <Loader width="25px" height="25px" />
                                  ) : (
                                    "Send Email"
                                  )}
                                </Button>
                              </Box>
                            </Box>
                          </>
                        );
                      }}
                    </Formik>
                  </Box>
                </Box>
              ) : (
                ""
              )}
              <Box
                marginTop={"5rem"}
                width="50%"
                display={"flex"}
                justifyContent="center"
                alignItems={"center"}
                flexDirection="column"
              >
                <Box>
                  <Text color={"#141D43"} fontSize="xs" fontWeight={"500"}>
                    Powered by
                  </Text>
                </Box>
                <a
                  target={"_blank"}
                  rel="noreferrer noopener"
                  href="https://emertech.io/"
                >
                  <Image src={emertechLogo} width="120px" />
                </a>
              </Box>
            </Box>
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
}

export default SignIn;
